<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Acompanhamento da criança"
    >
        <BoxDesenvolvimentoCrianca
            :data="data"
            readonly
        />

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import BoxDesenvolvimentoCrianca from '@/components/ambulatorio/atendimento-enfermagem/components/enfermagem/components/soap/components/objetivo/components/desenvolvimento-crianca/Index'

export default {
    components: {BoxDesenvolvimentoCrianca},
    methods: {
        open() {
            this.$refs.RkmModal.show()
        },
    },
    props: {
        data: {required: true, type: Object},
        readonly: {type: Boolean, default: false},
    },
}
</script>